import { getDocumentMeta } from "utils/getDocumentMeta";

export const areExtendedPatientNameFieldsEnabled = (): boolean => {
  return getDocumentMeta("enable_extended_patient_name_fields") === "1";
};
